'use strict'

/**
 * External Dependencies
 */
import 'jquery'
import { isIE } from './utils/isIE'

require('./setup')

if(!isIE()) {
  require('./intro-parallax')
  require('./cookies')
  require('./gsap-lazy')
  require('./menu')
  require('./popup')
  require('./video-popup')
  require('./blocks/alcohol')
  require('./blocks/fines')
  require('./blocks/reviews')
  require('./content-animations')
  require('./intro-sequence-animation')

  require('./game/app')

} else {

  $('header, footer, .main, .popup, .video-popup, .mobile-hamburger, .cookies')
  $('body').addClass('is-ie')

}

